import { createSlice } from '@reduxjs/toolkit';
import { fetchOrderBuilder, fetchOrdersBuilder, setOrderStateBuilder } from './builder';

const initialState = {
  orders: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
    perPage: 0,
  },
  order: { data: [], loading: false },
  fetchOrdersPending: false,
  setOrderStatePending: false,
};

export const orderSlice = createSlice({
  name: 'orderInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    fetchOrderBuilder(builder);
    fetchOrdersBuilder(builder);
    setOrderStateBuilder(builder);
    builder.addCase('logout', () => ({ ...initialState }));
  },
});

export const {} = orderSlice.actions;

export const selectOrder = state => state.orderInfo.order;
export const selectOrders = state => state.orderInfo.orders;
export const selectFetchOrdersPending = state => state.orderInfo.fetchOrdersPending;
export const selectSetOrderStatePending = state => state.orderInfo.setOrderStatePending;

export default orderSlice.reducer;
